import axios from "src/lib/axios";

// Home Section & Metatag

export const getAllSections = async () => {
  const { data: response } = await axios.get(`/landing-page/manage/section`);
  return response.data;
};

/**
 *
 * @param {Object} data
 * @param {Object[]} data.section - re-arranged section object array
 * @returns
 */
export const moveSectionPosition = async (data) => {
  const { data: response } = await axios.patch(
    `/landing-page/manage/position`,
    data,
  );
  return response.data;
};

export const editMetaTag = async (data) => {
  const { data: response } = await axios.patch(
    `/landing-page/manage/metatag`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data", // do not forget this
      },
    },
  );
  return response.data;
};

// Home Banner

/**
 *
 * @param {Object} data
 * @param {String} data.link
 * @param {File} data.image
 * @returns
 */
export const createBanner = async (data) => {
  const { data: response } = await axios.post(
    `/landing-page/manage/banner`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data", // do not forget this
      },
    },
  );
  return response.data;
};

/**
 *
 * @param {Object} data
 * @param {String} data.link
 * @param {File} data.image
 * @returns
 */
export const editBanner = async (id, data) => {
  const { data: response } = await axios.patch(
    `/landing-page/manage/banner/${id}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data", // do not forget this
      },
    },
  );
  return response.data;
};

export const getAllBanners = async () => {
  const { data: response } = await axios.get(`/landing-page/banner`);
  return response.data;
};

/**
 *
 * @param {Object[]} data - new rearranged banner positions
 * @returns
 */
export const moveBannerPosition = async (data) => {
  const { data: response } = await axios.patch(
    `/landing-page/manage/banner/position`,
    data,
  );
  return response.data;
};

/**
 *
 * @param {ObjectId} id - banner id
 * @param {Boolean} isPublic - banner public status
 * @returns
 */
export const togglePublicBanner = async (id, isPublic) => {
  const { data: response } = await axios.patch(
    `/landing-page/manage/banner/public/${id}`,
    {
      is_public: isPublic,
    },
  );
  return response.data;
};

/**
 *
 * @param {ObjectId} id - banner id
 * @returns
 */
export const deleteBanner = async (id) => {
  const { data: response } = await axios.delete(
    `/landing-page/manage/banner/delete/${id}`,
  );
  return response.data;
};

// Home Category

export const getCategories = async () => {
  const { data: response } = await axios.get(`/landing-page/categories`);
  return response.data;
};

// export const createCategory = async (data) => {
//   const { data: response } = await axios.post(
//     `/landing-page/manage/category`,
//     data,
//     {
//       headers: {
//         "Content-Type": "multipart/form-data", // do not forget this
//       },
//     }
//   );
//   return response.data;
// };

export const updateCategory = async (id, data) => {
  const { data: response } = await axios.patch(
    `/landing-page/manage/categories/${id}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data", // do not forget this
      },
    },
  );
  return response.data;
};

/**
 *
 * @param {Object[]} data - new rearranged category positions
 * @returns
 */
export const moveCategoryPosition = async (data) => {
  const { data: response } = await axios.patch(
    `/landing-page/manage/categories/position`,
    data,
  );
  return response.data;
};

// Home Features

export const getFeatures = async () => {
  const { data: response } = await axios.get(`/landing-page/feature`);
  return response.data;
};

export const moveFeaturePosition = async (data) => {
  const { data: response } = await axios.patch(
    `/landing-page/manage/feature/position`,
    data,
  );
  return response.data;
};

// Home Product Suggestion

export const getProductSuggest = async () => {
  const { data: response } = await axios.get(`/landing-page/product-suggest`);
  return response.data;
};

export const updateProductSuggest = async (data) => {
  const { data: response } = await axios.put(
    `/landing-page/manage/product-suggest`,
    data,
  );
  return response.data;
};

// Home Blog Suggestion

export const getBlogSuggest = async () => {
  const { data: response } = await axios.get(`/landing-page/blog-suggest`);
  return response.data;
};

export const updateBlogSuggest = async (data) => {
  const { data: response } = await axios.put(
    `/landing-page/manage/blog-suggest`,
    data,
  );
  return response.data;
};

// Suitable Area Room

export const getSuitableAreaRoom = async () => {
  const { data: response } = await axios.get(`/suitable-area-room`);
  return response.data;
};

export const updateSuitableAreaRoom = async (id, data) => {
  const { data: response } = await axios.patch(
    `suitable-area-room/${id}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data", // do not forget this
      },
    },
  );
  return response.data;
};

export const moveSuitableAreaRoomPosition = async (data) => {
  const { data: response } = await axios.patch(
    `suitable-area-room/position`,
    data,
  );
  return response.data;
};
